import { useState, useEffect, useContext} from 'react';
import { useHttpClient } from './http-hook';
import { AuthContext } from '../../shared/context/auth-context';

export const useCustomers = () => {
    const [customers, setCustomers] = useState([]);
    const { sendRequest } = useHttpClient();
    const auth = useContext(AuthContext);

    useEffect(() => {
        const fetchCustomers = async () => {
          try {
            const responseCustomerData = await sendRequest(
              process.env.REACT_APP_BACKEND_URL+"/customers",
              "GET",
              null,
              {Authorization: 'Bearer '+ auth.token}
            );
            setCustomers(responseCustomerData.customers);
          } catch (err) {}
        };
        fetchCustomers();
      }, [sendRequest, auth.token]);

      const suggestedCustomers = customers.map(customer => {
        return({
          name: customer.name + " " + customer.lastname,
          phone: customer.phone
        })
      })
    return { customers, suggestedCustomers };
}